import { SUBMIT_LOCK_MS } from '#pplx/frontend/composer-sdk/submitLock.js';
export const MAX_WORKSPACE_DIRECTORIES = 1;
export const RECENT_WORKSPACE_DIRECTORIES_STORAGE_KEY = 'pplx.computer.workspace-folders.recent.v1';
export const SELECTED_WORKSPACE_DIRECTORIES_STORAGE_KEY = 'pplx.computer.workspace-folders.selected.v1';
export const limitWorkspaceDirectories = (dirs) => (dirs ?? []).slice(0, MAX_WORKSPACE_DIRECTORIES);
export const workspaceDirectorySyncKey = (workspaceDirectories) => workspaceDirectories?.map((dir) => `${dir.path}\u0000${dir.name}`).join('\u0001');
/**
 * Derives a display name from a directory path. Handles trailing separators and
 * mixed `\`/`/` separators so the basename is stable across platforms.
 */
export const workspaceDirectoryNameFromPath = (path) => {
    const normalized = path.replace(/[\\/]+$/, '');
    const parts = normalized.split(/[\\/]/);
    return parts.at(-1) || path;
};
export const normalizeWorkspaceDirectory = (dir) => ({
    path: dir.path,
    name: dir.name || workspaceDirectoryNameFromPath(dir.path),
});
export const MAX_RECENT_WORKSPACE_DIRECTORIES = 10;
/**
 * Builds the recent-directory MRU list: selected entries first, then prior
 * entries, de-duplicated by path and capped at MAX_RECENT_WORKSPACE_DIRECTORIES.
 */
export const mergeRecentDirectories = (selected, previous) => {
    const seen = new Set();
    const merged = [...selected, ...previous].flatMap((dir) => {
        const normalized = normalizeWorkspaceDirectory(dir);
        if (!normalized.path || seen.has(normalized.path))
            return [];
        seen.add(normalized.path);
        return [normalized];
    });
    return merged.slice(0, MAX_RECENT_WORKSPACE_DIRECTORIES);
};
/** De-duplicates directories by path, preserving order and normalizing names. */
export const dedupeWorkspaceDirectories = (directories) => {
    const seen = new Set();
    return directories.flatMap((dir) => {
        const normalized = normalizeWorkspaceDirectory(dir);
        if (!normalized.path || seen.has(normalized.path))
            return [];
        seen.add(normalized.path);
        return [normalized];
    });
};
export const QUERY_SUBMIT_DEBOUNCE_MS = SUBMIT_LOCK_MS;
export const COMPUTER_COMMAND_MENU_TRIGGER = '/';
const EMPTY_OMITTED_SEARCH_MODES = [];
export function normalizeAskInputSearchModeControls(controls) {
    if (controls?.enabled === false) {
        return {
            enabled: false,
            toggleVisibility: 'all',
            omittedModes: EMPTY_OMITTED_SEARCH_MODES,
        };
    }
    return {
        enabled: true,
        toggleVisibility: controls?.toggle?.visibility ?? 'all',
        omittedModes: controls?.omittedModes ?? EMPTY_OMITTED_SEARCH_MODES,
    };
}
//# sourceMappingURL=index.js.map